import { useEffect, useState } from 'react';

// Shared, three.js-free layout knobs for the hero and the fixed page backdrop
// (kept out of EarthScene so the main bundle does not pull in three).

export type SceneLayout = 'split' | 'stacked';

export interface BackdropParams {
  sun: [number, number]; // ember glow position in viewport uv (0..1, bottom-left origin)
  horizon: number; // cloud-sea horizon, fraction of the viewport height from the bottom
  floor: number; // cloud-sea strength
  ember: number; // ember glow strength
}

export type Visual = 'globe' | 'hardware' | 'warehouse';

// REACT_APP_LANDING=cosmos -> the globe (/site1); =hardware -> the rendered hardware set (/site2);
// =warehouse -> the photo of the Changi FTZ warehouse (/site3)
const LANDING = process.env.REACT_APP_LANDING;
export const VISUAL: Visual = LANDING === 'hardware' ? 'hardware' : LANDING === 'warehouse' ? 'warehouse' : 'globe';

const PARAMS: Record<Visual, Record<SceneLayout, BackdropParams>> = {
  globe: {
    split: { sun: [0.84, 0.82], horizon: 0.3, floor: 0, ember: 0.9 },
    stacked: { sun: [0.78, 0.92], horizon: 0.24, floor: 0, ember: 0.8 },
  },
  hardware: {
    split: { sun: [0.92, 0.9], horizon: 0.3, floor: 0, ember: 0.5 },
    stacked: { sun: [0.88, 0.96], horizon: 0.24, floor: 0, ember: 0.45 },
  },
  warehouse: {
    split: { sun: [0.92, 0.9], horizon: 0.3, floor: 0, ember: 0 },
    stacked: { sun: [0.88, 0.96], horizon: 0.24, floor: 0, ember: 0 },
  },
};

export const BACKDROP_PARAMS: Record<SceneLayout, BackdropParams> = PARAMS[VISUAL];

// Globe right of the copy on desktop, above it on phones/tablets.
export const useSceneLayout = (): SceneLayout => {
  const [layout, setLayout] = useState<SceneLayout>(() =>
    typeof window !== 'undefined' && window.matchMedia('(min-width: 1024px)').matches ? 'split' : 'stacked',
  );
  useEffect(() => {
    const mq = window.matchMedia('(min-width: 1024px)');
    const update = () => setLayout(mq.matches ? 'split' : 'stacked');
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);
  return layout;
};
